import React from 'react';

import { QuoteCardWithScoreImprovements } from '@marketing/components/testimonial_card';

import MateusHeadshot from './assets/mateus_headshot.png';
import NishantHeadshot from './assets/nishant_headshot.png';

export default (props) => {
  return (
    <div className="d-flex flex-column flex-lg-row gap-m">
      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'TOEFL Score', score: 6, scoreIncrease: 'First Attempt!' }
          ]}
          studentAvatar={NishantHeadshot}
          studentName="Nishant M."
          style={{ height: '100%' }}
        >
          The video lectures were absolutely awesome and helped me a lot in my journey. Also, the practice questions available at Magoosh assisted me in solving the questions I later faced in the actual TOEFL. The resources and help section allowed me to explore various speaking and writing templates, which were crucial in my preparation.
        </QuoteCardWithScoreImprovements>
      </div>

      <div className="flex-1">
        <QuoteCardWithScoreImprovements
          scores={[
            { name: 'TOEFL Score', score: 6, scoreIncrease: 'First Attempt!' }
          ]}
          studentAvatar={MateusHeadshot}
          studentName="Mateus G."
          style={{ height: '100%' }}
        >
          Magoosh enabled me to understand the overall structure of the test, what questions to expect and how to effectively answer them. Furthermore, it helped me learn how to take notes during the test, something that I did not have prior knowledge of.
        </QuoteCardWithScoreImprovements>
      </div>
    </div>
  );
};
